import React from "react"
import { Link } from "gatsby"
import { BarraSoluciones } from "../../../BarraSoluciones"
import { SolucionesHeaders } from "../../SolucionesHeaders"
import { CarouselSection } from "../../../CarouselSection"
import { VideowallImg } from "../../../CarouselImages/VideowallImg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheck } from "@fortawesome/free-solid-svg-icons"

import "./info.scss"
import "./carousel.scss"

export const InfoSection = ({ classTitle, mainTitle }) => {
  const logoName = "videowall-logo"
  return (
    <>
      <div className={`info-${classTitle}-container`}>
        <SolucionesHeaders
          titleSolucion={mainTitle.toUpperCase()}
          cNameSolucion={classTitle}
          logoSVGName={logoName}
        />
        <div className={`info-${classTitle}-detalles-container`}>
          <div
            className={`info-${classTitle}-detalles-text-descripcion`}
            data-sal="slide-up"
            data-sal-delay="200"
            data-sal-easing="ease"
          >
            <p>
              En <span>Skol Solutions </span>
              tenemos todas las opciones en Displays LED, Indoor, Outdoor y
              Video Wall de grado comercial de acuerdo a los requerimientos de
              nuestros clientes.
            </p>
            <p>
              Proveemos varias opciones de acuerdo al tamaño de la sala o
              auditorio, al uso que se le vaya a dar, entre otros.
            </p>
            <p>Entregamos proyectos y soluciones “Llave en mano”.</p>
          </div>
          <div
            className={`info-${classTitle}-detalles-text`}
            data-sal="slide-up"
            data-sal-delay="200"
            data-sal-easing="ease"
          >
            <div className={`info-${classTitle}-detalles-text-equip-title`}>
              <h6>Displays y Video Walls para:</h6>
            </div>
            <div className={`info-${classTitle}-detalles-text-equip-container`}>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Negocios (Desde Salas pequeñas a Grandes Salas)</span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Educación</span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Centros comerciales</span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Hotelería</span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Auditorios</span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Retail</span>
              </div>
              <div className="equip-item-container ">
                <FontAwesomeIcon icon={faCheck} size="1x" color="#FF641F" />
                <span>Aeropuertos</span>
              </div>
            </div>
          </div>

          <CarouselSection
            classTitle={classTitle}
            images={VideowallImg}
            s1920="530px"
            s1366="490px"
            s1024="327px"
            s768="228px"
            s640="228px"
            s360="192px"
          />
        </div>

        <div
          className={`info-${classTitle}-button-container`}
          data-sal="slide-up"
          data-sal-delay="200"
          data-sal-easing="ease"
        >
          <Link className="soluciones-btn" to="/contacto">
            <button className={`${classTitle}-btn-cotizar"`}>COTIZAR</button>
          </Link>
        </div>

        <BarraSoluciones />
      </div>
    </>
  )
}
